// extracted by mini-css-extract-plugin
export default {"labelText":"StartAndEndTime_labelText__WNk7g","labelDisabled":"StartAndEndTime_labelDisabled__XJL5e"};